import React, {useState} from 'react';

import {
  ImpressumContainer,
  ImpressumContant,
  ImpressumH1,
  ImpressumH2,
  ImpressumP1,
  ImpressumP2,
  ImpressumLinks
} from './ImpressumElements'

import { 
  CloseIcon
} from '../components/Sidebar/SidebarElements';

const ImpressumPage = () => {
  window.scrollTo(0, 0)
  return (
    <ImpressumContainer id="impressum">
      <ImpressumContant>
        <ImpressumLinks to='/'> 
          <CloseIcon />
        </ImpressumLinks>

        <ImpressumH1>Impressum</ImpressumH1>     

        <ImpressumP1>
          B2B Upgrade
        </ImpressumP1>
        <ImpressumP1>
          Mühlenstraße 8a
          <br />
          14167 Berlin
        </ImpressumP1>
        <ImpressumP1>
          Telefon: 030 / 253 23 926
          <br />
          E-Mail: info@b2b-upgrade.com
        </ImpressumP1>

        <ImpressumH2>Haftungsausschluss:</ImpressumH2>
        <ImpressumP2>
          Haftung für Inhalte. Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. 
          Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr 
          übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen 
          Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
          Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
          Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von 
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. 
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten 
          Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir 
          diese Inhalte umgehend entfernen.
        </ImpressumP2>

        <ImpressumH2>Datenschutzerklärung:</ImpressumH2>
        <ImpressumP2>
          Diese Website dient ausschließlich der Bereitstellung von Informationen über unser Unternehmen. 
          Es werden keine personenbezogenen Daten über Formulare erhoben, keine Cookies gesetzt, und keine externen Dienste wie Google Analytics oder Google Fonts eingebunden.
          <br /><br />
          Unsere Website wird bei der STRATO AG, Pascalstraße 10, 10587 Berlin, gehostet. Beim Besuch der Website 
          speichert der Hostinganbieter automatisch sogenannte Server-Logfiles, die folgende Informationen enthalten:
          <ul>
            <li>Besuchte Seite (Domain)</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Referrer-URL (sofern übermittelt)</li>
            <li>Browsertyp und Version</li>
            <li>Betriebssystem</li>
            <li>IP-Adresse (anonymisiert nach spätestens 7 Tagen)</li>
          </ul>
          Diese Daten dienen der Sicherstellung des technischen Betriebs und der Sicherheit der Website. 
          Eine Zusammenführung dieser Daten mit anderen Datenquellen erfolgt nicht.
          <br /><br />
          Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
          Mit der STRATO AG besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
          <br /><br />
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit 
          und Widerspruch gegen die Verarbeitung Ihrer Daten gemäß den Artikeln 15 bis 21 DSGVO. 
          Zudem haben Sie ein Beschwerderecht bei der zuständigen Datenschutzaufsichtsbehörde.
        </ImpressumP2>
      </ImpressumContant>
    </ImpressumContainer>
  )
}

export default ImpressumPage;
